/* eslint-disable no-param-reassign */
import axios from 'axios'

import { getLocalStorageOnboardingFormToken } from '../utils/localStorage'

import { log } from './log'
import { getSession, removeSession } from './session'

const url = process.env.REACT_APP_BFB_API
const url_new = process.env.REACT_APP_BFB_API_NEW

// Set config defaults when creating the instance
const instance = axios.create({
  baseURL: url
})

// Add a request interceptor
instance.interceptors.request.use((config) => {
  const authHeader = config.headers.getAuthorization()

  if (!authHeader) {
    config.headers.setAuthorization('X-BAREKSA-WEB')
    config.headers.setContentType('application/json')
  }

  const session = getSession('b-bfb')

  if (session) {
    config.headers.set('X-TOKEN-CLIENT', session.local_token)
    config.headers.set('X-BAREKSA-USER', session.id)
    config.headers.set('X-BAREKSA-INVESTOR', session.investor_id)
  }

  if (config.useNewAPI) {
    config.baseURL = url_new
  }

  if (config.useOnboardingFormToken) {
    const onboardingFormToken = getLocalStorageOnboardingFormToken()
    if (onboardingFormToken) {
      config.headers.setAuthorization(onboardingFormToken)
    }
  }

  return config
})

// Add a response interceptor
instance.interceptors.response.use(
  (response) =>
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    response,
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // error response for unauthrorized
    const { response } = error

    const responseMessage =
      error.response?.data?.data?.message || error.response?.data?.message
    const requestMessage =
      error.request?.response?.data?.data?.message ||
      error.request?.response?.data?.message
    const errorMessage = responseMessage || requestMessage || error.message
    const requestData = error.response?.config || {}
    const responseData = error.response?.data || error.request?.response

    if (error.response?.status) {
      log({
        errorType: 'error_response_api',
        message: errorMessage,
        description: errorMessage,
        payload: {
          apiUrl: error.response?.config?.url || error.request?.responseURL,
          request: {
            headers: requestData.headers,
            method: requestData.method,
            body: requestData.data || requestData.body || {},
            url: requestData.url
          },
          response: responseData
        }
      })
    }

    if (response && response.data.status === 401) {
      if (location.pathname !== '/') {
        window.location = '/'
        removeSession('b-bfb')
        removeSession('b-bfb-login')
        removeSession('b-bfb-ph')
        removeSession('otp-attm')
        sessionStorage.removeItem('b-bfb-cd')
      }
    }

    return Promise.reject(error)
  }
)

export default instance
